module.exports = __webpack_public_path__ + "static/media/Modlin_Group_Maggie_500.0210d3cd.jpg";